<!--
 * @Author: lijh(¯﹃¯*)
 * @Date: 2023-12-13 16:44:19
 * @LastEditors: lijh(¯﹃¯*)
 * @LastEditTime: 2023-12-21 15:54:52
 * @Description: 首页功能模块共用组件
-->
<template>
  <div class="func-module">
    <div class="container-head" :style="{ backgroundColor: titleColor }">
      <div class="container-head-title">
        <i :class="[icon, 'iconfont', 'head-icon']"></i>
        <span class="title-text">{{ title }}</span>
        <template v-if="tips">
          <el-tooltip
            :content="tips"
            placement="right"
            popper-class="toolTipStyle"
          >
            <i class="iconfont icon-tishi tips-icon"></i>
          </el-tooltip>
        </template>

        <a
          v-if="showViewAll"
          href="javascript:void (0)"
          class="title-more"
          @click="hanleViewAll"
        >
          查看全部 >
        </a>
        <button
          v-if="showPublish"
          :style="{ '--hover-color': publishColor, '--hoverColor': hoverColor }"
          class="iconfont icon-paperPlane  publish-operation-btn"
          @click="handlePublish"
        >
          发布
        </button>
      </div>
    </div>
    <slot name="toDo"></slot>
    <div class="container-body">
      <!-- 内容自定义 -->
      <slot v-if="custom"></slot>
      <template v-else>
        <div class="container-body-items" v-if="listData.length > 0">
          <div class="item" v-for="(item, index) in listData" :key="index">
            <div
              class="item-content"
              v-if="index < showNum"
              :style="{ backgroundColor: rowColor }"
              :title="`点击进入${title}详情`"
              @click="intoDetail(item)"
            >
              <!-- 作用域插槽 -->
              <slot name="row" :item="item" :index="index"></slot>
            </div>
          </div>
        </div>
        <div class="empty-data" v-else>
          <span class="empty-data-image"> </span>
          <span class="empty-data-text">暂无数据</span>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "FuncModule",
  components: {},
  props: {
    listData: {
      type: Array,
      default: () => {
        return [];
      }
    },
    // 标题
    title: {
      type: String,
      default: ""
    },
    // 标题图标
    icon: {
      type: String,
      default: ""
    },
    // 头部颜色
    titleColor: {
      type: String,
      default: "#41c9ff"
    },
    // 行颜色
    rowColor: {
      type: String,
      default: ""
    },
    // 发布按钮颜色
    publishColor: {
      type: String,
      default: ""
    },
    hoverColor: {
      type: String,
      default: ""
    },
    tips: {
      type: String,
      default: ""
    },
    // 自定义插槽
    custom: {
      type: Boolean,
      default: false
    },
    // 自定义插槽
    showViewAll: {
      type: Boolean,
      default: true
    },
    showNum: {
      type: Number,
      default: 10
    }
  },
  data() {
    return {
      showPublish: false
    };
  },
  watch: {
    userPower: {
      immediate: true,
      handler(newVal) {
        // 通讯录、待办事项、自留地无发布，动态共享、病例讨论、三角地所有角色权限有，大喇叭只有超级管理员和系统管理员
        const that = this;
        switch (this.title) {
          case "通讯录":
            this.showPublish = false;
            break;
          case "待办事项":
            this.showPublish = that.$store.state.userPowerStore.deptPower;
            break;
          case "自留地":
            this.showPublish = false;
            break;
          case "动态共享":
            this.showPublish = !that.$store.state.userPowerStore
              .unApproveMember;
            break;
          case "病例讨论":
            this.showPublish = !this.$store.state.userPowerStore
              .unApproveMember;
            break;
          case "三角地":
            this.showPublish = !this.$store.state.userPowerStore
              .unApproveMember;
            break;
          case "大喇叭":
            this.showPublish =
              this.$store.state.userPowerStore.systemPower ||
              this.$store.state.userPowerStore.superPower;
            break;
          default:
            this.showPublish = false;
        }
      }
    }
  },
  computed: {
    ...mapState({
      userPower: state => state.userPowerStore.userPower
    })
  },
  mounted() {},
  methods: {
    intoDetail(item) {
      this.$emit("intoDetail", item);
    },
    hanleViewAll() {
      this.$emit("hanleViewAll");
    },
    handlePublish() {
      this.$emit("handlePublish");
    }
  }
};
</script>
<style lang="scss" scoped>
.func-module {
  display: flex;
  flex-direction: column;
  flex: 1;
  border-radius: 8px;
  background-color: #fff;
  overflow: hidden;
  box-shadow: 1px 2px 5px #ccc;
  .container-head {
    border-bottom: 1px solid #f5f5f5;
    padding: 10px;
    line-height: 20px;
    overflow: auto;
    background: url(/static/images/bgimage.png) no-repeat;
    background-size: cover;
    &-title {
      display: block;
      vertical-align: middle;
      .title-text {
        display: inline-block;
        text-align: center;
        vertical-align: middle;
        padding-left: 5px;
        color: white;
        font-size: 16px;
        font-style: normal;
        letter-spacing: 0px;
        line-height: 20px;
        text-decoration: none;
        font-family: SourceHanSansSC;
        font-weight: 700;
      }
      .title-more {
        cursor: pointer;
        float: right;
        color: #fff;
        font-size: 12px;
        line-height: 20px;
        &:hover,
        &:active {
          color: #eae9e9;
        }
      }
      .publish-operation-btn {
        float: right;
        font-size: 15px;
        padding: 0 10px;
        border-radius: 5px;
        text-align: center;
        box-shadow: 0 0px 20px 0px #efebe7;
        font-weight: bold;
        margin: 0 10px;
        color: #f3f3f3;
        background-color: var(--publishColor);
        &:hover {
          background-color: var(--hoverColor);
        }
        &::before {
          margin: 0 5px;
        }
      }
    }
    .head-icon {
      display: inline-block;
      text-align: center;
      vertical-align: middle;
      color: #fff;
      font-size: 20px;
    }
  }
  .container-body {
    padding: 10px;
    overflow: auto;
    flex: 1;
    display: flex;
    flex-direction: column;
    &-items {
      flex: 1;
      overflow-y: auto;
      overflow-x: hidden;
      .item {
        margin-bottom: 10px;
        .item-content {
          background: rgb(235, 247, 253);
          border-radius: 4px;
          padding: 10px 5px;
          margin-right: 5px;
          cursor: pointer;
        }
      }
      .item:last-child {
        margin-bottom: 0;
      }
    }
    .empty-data {
      background-position: center;
      background-size: contain;
      background-repeat: no-repeat;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 100%;
      &-image {
        width: 100%;
        flex: 1;
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
        align-self: center;
        max-width: 300px;
        background-image: url("/static/images/empty_data.png");
      }
      &-text {
        font-size: 18px;
        color: #999999;
        padding-bottom: 20px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/FuncModule.vue